/**
 * Identity glyph — the small square/circle that stands in for a typed thing.
 *  - square: an ENTITY (a record of some type) — rounded-sm, type initial
 *  - circle: an ACTOR (a person) — rounded-full, name initials
 *
 * Single source for this visual so the primary column, reference cells, and
 * (later) the peek drawer can't drift apart. Colour comes from the staging
 * theme via `bg-primary`; per-type colour arrives with type `display` metadata.
 */
export function TypeGlyph({
  glyph,
  shape = 'square',
  color,
}: {
  glyph: string
  shape?: 'square' | 'circle'
  /** Per-type colour from `type.display.color` (data, not a magic constant).
   *  Falls back to the theme's `bg-primary` when the type has no colour. */
  color?: string
}) {
  return (
    <span
      style={color ? { backgroundColor: color } : undefined}
      className={`inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center text-[9px] font-semibold leading-none text-primary-foreground ${
        color ? '' : 'bg-primary'
      } ${shape === 'circle' ? 'rounded-full' : 'rounded-sm'}`}
    >
      {glyph}
    </span>
  )
}
